import React from "react";
import FeaturedImage from "../FeaturedImage";

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,

    replaceSelected,
    theExcerpt,
  } = props;

  let categories;
  let categoryItems;
  let featuredImage;
  let author;
  let excerpt;
  let date;

  if (post.hasOwnProperty("featured_image") && post.featured_image) {
    featuredImage = (
      <a href={post.link} className="blog-card__image">
        <figure>
          <FeaturedImage
            imageSize={"image-info-card"}
            image={post.featured_image}
            srcset={post.featured_image}
          ></FeaturedImage>
        </figure>
      </a>
    );
  } else {
    featuredImage = (
      <a href={post.link} className="blog-card__image">
        <figure
          dangerouslySetInnerHTML={{ __html: post.acf_data.default_image }}
        ></figure>
      </a>
    );
  }

  if (post.hasOwnProperty("the_categories") && post.the_categories.length > 0) {
    categories = post.the_categories;
  }

  if (categories && displayCategories) {
    categoryItems = categories.map((category, index) => {
      if (category.id === post.acf_data.category.id) {
        return (
          <a
            key={category.id}
            // onClick={() => {
            //   replaceSelected(category.id, category.taxonomy);
            // }}
            style={{backgroundColor: post.acf_data.category.color}}
          >
            {category.name}
          </a>
        );
      }
    });
  }

  if (post.the_author && displayAuthor) {
    author = <span className="author">By {post.the_author}</span>;
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = (
      <div
        className="blog-card__excerpt"
        dangerouslySetInnerHTML={{ __html: theExcerpt(post.excerpt.rendered) }}
      ></div>
    );
  }

  if (displayDate) {
    date = <time>{post.formatted_date}</time>;
  }

  return (
    <article id={`${postType}-${post.id}`} className="blog-card">
      {featuredImage}

      <div className="blog-card__content">
        <h4 className="blog-card__title">
          <a
            href={post.link}
            dangerouslySetInnerHTML={{ __html: post.title.rendered }}
          ></a>
        </h4>

        <div className="blog-card__details">
          <div className="blog-card__category">
            {categoryItems}
          </div>

          <div className="blog-card__date">
            {date}
          </div>
        </div>
      </div>
    </article>
  );
}

export default post;
